var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _g, _g2, _path50, _path51, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 106,
    viewBox: "0 0 159 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74023 75.983L20.8693 31.8597L21.3717 29.6504L73.4921 41.8332L112.3 48.5874L129.569 72.4913L124.168 71.3119L146.712 76.2355V102.81L112.74 105.02L81.216 103.947L46.9923 105.02L37.7614 103.947L35.3123 103.126H26.0185H22.7532L9.44045 101.737V92.9632L8.62411 91.8901V91.0695L9.44045 90.5014V85.0097H8.05895V75.983H6.74023Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8848 31.9352L41.4274 68.366L80.7212 72.8678V71.666L41.9962 66.5951L21.5168 30.4805L20.8848 31.9352Z",
    stroke: "#8FA1AC",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0596 66.5947L41.6172 68.3657",
    stroke: "#8FA1AC",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.803 72.035L113.105 47.6845L21.3903 29.5322L6.59961 75.0708H8.36943L22.0224 33.8963",
    stroke: "#8FA1AC",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M45.7251 77.2842L80.7208 80.1252L81.0364 102.212L45.7251 103.153L35.8646 102.077H33.6523V78.6124H35.8646L45.7251 77.2842Z",
    fill: "#B1D6DE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.681 75.3875L112.79 68.3037L81.0371 71.6066V73.8203V102.282",
    stroke: "#8FA1AC",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36914 75.0703V84.1148H12.2888V89.9968H8.36914V90.8191L9.00122 91.578V95.9105V100.812",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00195 100.244L19.4313 101.003L21.9596 100.687L33.6531 101.952L35.4861 101.699L46.1683 102.521L82.5129 101.762L112.79 103.533L147.428 100.624V74.8184",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44336 84.3682V89.9972",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.685 101.002L19.5586 56.2222L30.1775 52.3008V75.576L21.3916 76.2085L21.6445 100.685",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6133 54.3252V75.956",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1318 53.8193V75.9561",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7754 75.5126V55.5895L30.1773 54.957",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6147 56.6025L22.6553 57.4248L22.9081 75.9564",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5264 101.508V78.4226L35.4858 78.6124L45.1566 77.2842L80.7206 80.1252V101.897",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3457 69.1895V77.2852",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9736 78.6133V102.015",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M86.0854 79.4951H81.668V98.8057L86.0854 99.0581V79.4951Z",
    fill: "#B1D6DE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4844 77.916V102.33",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0566 78.8623V102.517",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M99.8945 99.6746V78.6131L105.71 78.5498V99.9276L99.8945 99.6746Z",
    fill: "#B1D6DE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6475 78.9922V102.267",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M72.832 79.4951V102.581",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M112.79 68.3037V103.533",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M81.668 79.4951H86.0854V99.0581L81.668 98.9952",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3779 78.6761V99.5479L105.836 99.8642V78.4863L98.3779 78.6761Z",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M100.021 78.6133V99.6116",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M124.23 98.8519V79.751L142.308 81.6484V97.7767L124.23 98.8519Z",
    fill: "#B1D6DE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M124.293 78.2334V99.042L144.077 97.9035V80.5103L124.293 78.2334Z",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M124.42 79.5615L142.308 81.459L144.078 80.447",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M142.308 81.6494V97.7777",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M128.148 80.0674V98.6623",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M133.521 80.6367V98.4727",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M138.136 81.1426V98.093",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0742 31.999L41.6168 68.3034",
    stroke: "#8FA1AC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.7178 75.893V57.3613L22.9706 57.1083L24.614 56.5391V75.893H22.7178Z",
    fill: "#B1D6DE"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M27.9004 75.6398V55.7167L30.1127 55.1475V75.6398H27.9004Z",
    fill: "#B1D6DE"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M74.7384 81.9014L50.4033 93.9185V95.8159L74.7384 81.9014Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M141.991 86.5811L127.77 93.6648V94.8033L141.991 86.5811Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M76.0656 86.0127L51.7305 98.0298V99.9273L76.0656 86.0127Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M142.561 88.7324L128.339 95.8162V96.9547L142.561 88.7324Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1309 73.3176L113.084 70.7617L146.712 76.6347",
    stroke: "#8FA1AC",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M30.2324 31.6094L45.4551 58.2962L109.517 64.8894L95.1633 44.6478L30.2324 31.6094Z",
    fill: "#8FA1AC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M158.055 101.557H149.296L114.788 105.021L84.6247 102.913L48.4164 103.816L37.7743 102.837L35.9482 103.138L24.2985 101.633L21.7797 102.009L11.3895 101.105H1",
    stroke: "#8FA1AC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3533 17.9123C33.9629 17.8488 33.6376 18.2296 33.8328 18.5469L43.3969 36.3173L51.79 51.8664C51.9201 52.1838 52.2454 52.3742 52.5707 52.3742L115.291 60.1805C115.681 60.2439 115.942 59.7997 115.746 59.4823L96.5085 29.8311C96.5085 29.8311 96.3133 29.6407 96.1832 29.6407L34.3533 17.9123Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M51.0615 21.1211L69.0469 54.252",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M67.4697 24.2754L85.4551 56.7752",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M82.9307 27.1162L101.232 59.3005",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M42.542 34.0586L105.333 43.8401",
    stroke: "white",
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-50-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.184 2C100.335 2 91.541 10.7943 91.541 21.6426C91.541 26.9143 93.6177 31.701 96.9977 35.2291V45.1043L104.196 40.0058C106.367 40.8325 108.722 41.2852 111.184 41.2852H112.275C123.123 41.2852 131.917 32.4909 131.917 21.6426C131.917 10.7943 123.123 2 112.275 2H111.184Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.184 2C100.335 2 91.541 10.7943 91.541 21.6426C91.541 26.9143 93.6177 31.701 96.9977 35.2291V45.1043L104.196 40.0058C106.367 40.8325 108.722 41.2852 111.184 41.2852H112.275C123.123 41.2852 131.917 32.4909 131.917 21.6426C131.917 10.7943 123.123 2 112.275 2H111.184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9977 35.2291H97.9977V34.8274L97.7198 34.5373L96.9977 35.2291ZM96.9977 45.1043H95.9977V47.0381L97.5758 45.9203L96.9977 45.1043ZM104.196 40.0058L104.551 39.0713L104.053 38.8814L103.618 39.1898L104.196 40.0058ZM92.541 21.6426C92.541 11.3466 100.888 3 111.184 3V1C99.783 1 90.541 10.242 90.541 21.6426H92.541ZM97.7198 34.5373C94.511 31.1879 92.541 26.6464 92.541 21.6426H90.541C90.541 27.1823 92.7245 32.2141 96.2756 35.9209L97.7198 34.5373ZM97.9977 45.1043V35.2291H95.9977V45.1043H97.9977ZM103.618 39.1898L96.4197 44.2883L97.5758 45.9203L104.774 40.8218L103.618 39.1898ZM111.184 40.2852C108.846 40.2852 106.611 39.8554 104.551 39.0713L103.84 40.9404C106.123 41.8097 108.599 42.2852 111.184 42.2852V40.2852ZM112.275 40.2852H111.184V42.2852H112.275V40.2852ZM130.917 21.6426C130.917 31.9386 122.571 40.2852 112.275 40.2852V42.2852C123.675 42.2852 132.917 33.0432 132.917 21.6426H130.917ZM112.275 3C122.571 3 130.917 11.3466 130.917 21.6426H132.917C132.917 10.242 123.675 1 112.275 1V3ZM111.184 3H112.275V1H111.184V3Z",
    fill: "#E6E6E6",
    mask: "url(#path-50-inside-1)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.115 29.9696C113.423 29.1392 113.069 28.1872 112.324 27.8433C111.578 27.4993 110.723 27.8936 110.414 28.724C110.105 29.5544 110.459 30.5064 111.205 30.8503C111.951 31.1943 112.806 30.8 113.115 29.9696Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.08 26.0642C116.473 25.4923 116.376 24.6688 115.86 24.2309C114.824 23.3486 113.585 22.8355 112.276 22.7473C110.536 22.6329 108.854 23.28 107.548 24.5708C107.064 25.0511 107.02 25.8779 107.451 26.4171C107.683 26.7079 108.006 26.855 108.329 26.855C108.605 26.855 108.883 26.7471 109.109 26.5249C109.946 25.6982 111.023 25.2799 112.138 25.355C112.978 25.4106 113.77 25.7374 114.433 26.3027C114.95 26.7439 115.687 26.636 116.08 26.0642Z",
    fill: "#F26829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.339 22.6131C119.771 22.0739 119.729 21.2504 119.248 20.7667C117.208 18.7341 114.576 17.6133 111.835 17.6133C109.017 17.6133 106.332 18.7864 104.269 20.9203C103.793 21.4105 103.767 22.2373 104.207 22.7667C104.439 23.0444 104.753 23.1849 105.067 23.1849C105.352 23.1849 105.639 23.0706 105.865 22.8353C107.491 21.1523 109.613 20.2275 111.835 20.2275C113.998 20.2275 116.073 21.1099 117.684 22.7144C118.165 23.198 118.905 23.149 119.339 22.6131Z",
    fill: "#F26829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.834 12.1846C107.725 12.1846 103.822 13.9165 100.84 17.0569C100.37 17.5536 100.35 18.3804 100.793 18.9065C101.025 19.1777 101.336 19.315 101.647 19.315C101.937 19.315 102.228 19.1973 102.454 18.9588C104.999 16.2759 108.33 14.7988 111.834 14.7988C115.274 14.7988 118.558 16.2269 121.085 18.8215C121.56 19.3117 122.303 19.2758 122.743 18.7464C123.183 18.217 123.151 17.387 122.675 16.9001C119.714 13.8577 115.863 12.1846 111.834 12.1846Z",
    fill: "#F26829"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M114.188 16.14L114.198 16.0792V16.0177C114.198 14.5144 113.166 13.042 111.609 13.042C110.051 13.042 109.02 14.5144 109.02 16.0177V16.0792L109.03 16.1399L110.303 23.8443C110.303 23.8443 110.303 23.8443 110.303 23.8443C110.416 24.5309 110.941 25.0335 111.609 25.0335C112.276 25.0335 112.801 24.5309 112.914 23.8443C112.914 23.8443 112.914 23.8443 112.914 23.8443L114.188 16.14Z",
    fill: "#F26829",
    stroke: "white",
    strokeWidth: 1.5
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M111.69 30.4431C112.926 30.4431 113.697 29.2862 113.697 28.1722C113.697 27.0583 112.926 25.9014 111.69 25.9014C110.455 25.9014 109.684 27.0583 109.684 28.1722C109.684 29.2862 110.455 30.4431 111.69 30.4431Z",
    fill: "#F26829",
    stroke: "white",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 89.541,
    y: 0,
    width: 48.3765,
    height: 51.1043,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.12625 0 0 0 0 0.2583 0 0 0 0 0.3 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcd);
export default __webpack_public_path__ + "static/media/home-icd.a798bb2c75e4f7b4b098d5d0c09899b7.svg";
export { ForwardRef as ReactComponent };